import { useContext, useEffect, useState } from 'react';
import Select from 'react-select';
import AdoDataContext from '../../context/AdoDataContext';

interface SelectADOProps {
    currAdo: string;
    filterByAdo: (ado: string) => void;
    isSummary: boolean;
}

const ADONameMapping: { [id: string]: string } = {
    "Adams County": "Adams County Development Council",
    "Chelan-Douglas Regional Port Authority": "Chelan - Douglas",
    "Clallam County": "Clallam County Economic Development Council",
    "Columbia River Economic Development Authority": "Columbia River Economic Development Authority",
    "Cowlitz Economic Development Council": "Cowlitz Economic Development Council",
    "Economic Alliance Snohomish County": "Economic Alliance Snohomish County",
    "Economic Development Alliance of Skagit County": "Economic Development Alliance of Skagit County",
    "Economic Development Board for Tacoma-Pierce County": "Economic Development Board for Tacoma-Pierce County",
    "Economic Development Council of Mason County": "Economic Development Council of Mason County",
    "Economic Development Team Jefferson": "Economic Development Council Team Jefferson",
    "Grant County Economic Development Council": "Grant County Economic Development Council",
    "Greater Grays Harbor, Inc.": "Greater Grays Harbor, Inc.",
    "Greater Seattle Chamber of Commerce": "Greater Seattle Chamber of Commerce",
    "Greater Spokane Incorporated": "Greater Spokane Incorporated",
    "Island County Economic Development Council": "Island County Economic Development Council",
    "Kitsap Economic Development Alliance": "Kitsap Economic Development Alliance",
    "Kittitas County Chamber of Commerce": "Kittitas County Chamber of Commerce",
    "Klickitat County Public Economic Development Authority": "Klickitat County Public Economic Development Authority",
    "Lewis Economic Development Council": "Economic Alliance for Lewis County",
    "Lincoln County Economic Development Council": "Lincoln County Economic Development Council",
    "Pacific County Economic Development Council": "Pacific County Economic Development Council",
    "Pend Oreille Economic Development Council": "Pend Oreille Economic Development Council",
    "Port of Bellingham": "Port of Bellingham",
    "Port of Columbia": "Port of Columbia",
    "Port of Douglas": "Chelan - Douglas",
    "Port of Walla Walla": "Port of Walla Walla",
    "Port of Whitman": "Port of Whitman",
    "SE WA Economic Development Association": "SE WA Economic Development Association (SEWEDA)",
    "San Juan County Economic Development Council": "San Juan County Economic Development Council",
    "Skamania County Economic Development Council": "Skamania County Economic Development Council",
    "The Economic Alliance": "The Economic Alliance",
    "Thurston County": "Thurston Economic Development Council",
    "Tri County Economic Development District": "Tri County Economic Development District",
    "Tri-City Development Council": "Tri-City Development Council (TRIDEC)",
    "Wahkiakum Chamber of Commerce": "Wahkiakum Chamber of Commerce",
    "Yakima County Development Association": "Yakima County Development Association"

};

function SelectADO({ currAdo, filterByAdo, isSummary }: SelectADOProps) {
    const { adoNames } = useContext(AdoDataContext);
    const [ado, setAdo] = useState<string>(currAdo || '');

    useEffect(() => {
        setAdo(currAdo);
    }, [currAdo]);

    const handleSelectChange = (selectedOption: { value: string; label: string } | null) => {
        const selectedAdo = selectedOption ? selectedOption.value : '';
        setAdo(selectedAdo);
        filterByAdo(selectedAdo);


        console.log("ado names: ", adoNames);

        // Send message to expand
        window.parent.postMessage({ message: "location", params: { location: ADONameMapping[selectedAdo], type: "ado"} }, "*");
        console.log('expand message sent');
    };

    return (
        <div className='md:mt-0 mt-2'>
            <Select
                options={adoNames}
                value={adoNames.find(option => option.value === ado)}
                onChange={handleSelectChange}
                placeholder="Select ADO"
                isClearable
                styles={{
                    control: (base) => ({
                        ...base,
                        borderColor: '#0A5F75',
                        boxShadow: 'none',
                        height: '36px',
                        minHeight: '36px',
                        borderRadius: '7px',
                        borderWidth: '2px',
                        width: isSummary ? '15rem' : '10rem',
                        marginRight: '1rem',
                        cursor: 'pointer',
                        '&:hover': {
                            borderColor: '#0B82A0',
                        },
                    }),
                    valueContainer: (base) => ({
                        ...base,
                        fontSize: '0.875rem',
                        padding: '0 0.5rem',
                        minHeight: '2rem',
                        height: '2rem',
                    }),
                    placeholder: (base) => ({
                        ...base,
                        color: '#0A5F75',
                        fontSize: '0.875rem',
                        fontWeight: 'bold',
                    }),
                    singleValue: (base) => ({
                        ...base,
                        color: '#0A5F75',
                        fontSize: '0.875rem',
                        fontWeight: 'bold'
                    }),
                    dropdownIndicator: (base) => ({
                        ...base,
                        color: '#0A5F75',
                        padding: '0',
                        '& hover': {
                            color: '#0B82A0'
                        }
                    }),
                    clearIndicator: (base) => ({
                        ...base,
                        padding: '0',
                    }),
                    indicatorsContainer: (base) => ({
                        ...base,
                        padding: '0 0.25rem',
                    }),
                    option: (base, state) => ({
                        ...base,
                        fontSize: '0.875rem',
                        backgroundColor: state.isSelected ? '#4D4D4D' : state.isFocused ? '#E2E8F0' : 'white',
                        borderRadius: '4px',
                        borderBottom: '1px solid #E2E8F0',
                        color: state.isSelected ? 'white' : '#4D4D4D',
                        '&:hover': {
                            backgroundColor: '#E2E8F0',
                            color: '#0A5F75'
                        },
                    }),
                    menu: (base) => ({
                        ...base,
                        width: isSummary ? '15rem' : '10rem',
                        position: 'absolute',
                        left: '0',
                        top: '2rem',
                        zIndex: 9999,
                        boxShadow: '0 8px 16px 0 rgba(0, 0, 0, 0.15)',
                        
                    }),
                    menuList: (base) => ({
                        ...base,
                        padding: '4px',
                        maxHeight: '200px',
                        overflowY: 'auto',
                        '::-webkit-scrollbar': {
                            width: '8px',
                        },
                        '::-webkit-scrollbar-track': {
                            background: '#ffffff',
                            borderRadius: '4px',
                        },
                        '::-webkit-scrollbar-thumb': {
                            background: '#E8E8E8',
                            borderRadius: '4px',
                            height: '50px',
                            padding: '10px'
                        },
                    }),
                }}
            />
        </div>
    );
}

export default SelectADO;